import React from "react";
import useAxios from "axios-hooks";
import { Link } from "react-router-dom";

import Api from "../../api";
import AllProjects from "../../assets/svg/AllProjects";
import { Button } from "../../components";

import styles from "./projects.module.scss";

const Filter = ({ activeTypes, activeTags, setTypes, setTags, reset }) => {
  const [{ data, loading, error }] = useAxios({ url: Api.filters });

  if (error) {
    // console.log(error);
  }

  return (
    <div>
      <div className={styles.projectsFilter}>
        <div className={styles.projectsCategories}>
          <button
            onClick={() => {
              reset();
            }}
            className={styles.ResetButton}
          >
            <AllProjects
              className={
                activeTypes.length > 0 || activeTags.length > 0
                  ? styles.IconDisabled
                  : styles.Icon
              }
            />
          </button>

          {data &&
            data.types.map((type) => {
              return (
                <span
                  key={type.id}
                  className={
                    activeTypes.includes(type.ident)
                      ? styles.projectCategoryItemActive
                      : styles.projectCategoryItem
                  }
                  onClick={() => {
                    setTypes(type.ident);
                  }}
                >
                  {type.multiple_title}
                </span>
              );
            })}
        </div>

        <div className={styles.projectsTags}>
          {data &&
            data.tags.map((tag) => {
              return (
                <Button
                  key={tag.id}
                  isActive={activeTags.includes(tag.ident)}
                  isSmall={true}
                  onClick={() => {
                    setTags(tag.ident);
                  }}
                >
                  {tag.multiple_title}
                </Button>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Filter;
